// extracted by mini-css-extract-plugin
export default {"root":"_2DR4u","small":"_18zaU","normal":"_2g_Rx"};